exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title-35660{font-size:21px}.calendar-f270c{padding:24px;border-radius:12px;background-color:#fff;box-shadow:0 4px 20px 0 rgba(112,112,128,.1)}.calendar-f270c .ant-picker-cell{cursor:auto;pointer-events:all}", ""]);

// Exports
exports.locals = {
	"title": "title-35660",
	"calendar": "calendar-f270c"
};